function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader?minimize!../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-7fbf202c\",\"scoped\":false,\"hasInlineConfig\":false}!less-loader!../node_modules/vue-loader/lib/selector?type=styles&index=0!./tree.vue")
}
var Component = require("!../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../node_modules/vue-loader/lib/selector?type=script&index=0!./tree.vue"),
  /* template */
  require("!!../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-7fbf202c\",\"hasScoped\":false}!../node_modules/vue-loader/lib/selector?type=template&index=0!./tree.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/tree.vue
// module id = 1
// module chunks = 0